const URL = process.env.REACT_APP_COCKPIT_URL;
const KEY = process.env.REACT_APP_COCKPIT_API_KEY;

if (!URL) {
  throw new Error(
    'Missing REACT_APP_COCKPIT_URL in .env'
  );
}

if (!KEY) {
  throw new Error(
    'Missing REACT_APP_COCKPIT_API_KEY in .env'
  );
}

export const COCKPIT_URL: string = URL;

const COCKPIT_KEY: string = KEY;

export async function cockpitGet<T>(
  path: string
): Promise<T> {
  const res = await fetch(
    `${COCKPIT_URL}${path}`,
    {
      method: 'GET',
      headers: {
        'API-KEY': COCKPIT_KEY,
      },
      credentials: 'omit',
    }
  );

  if (!res.ok) {
    const text = await res.text();

    throw new Error(
      `Cockpit ${res.status}: ${text}`
    );
  }

  return res.json() as Promise<T>;
}

export const getCockpitAssetUrl = (
  path?: string
): string => {
  if (!path) {
    return '';
  }

  return `${COCKPIT_URL}/storage/uploads${path}`;
};